"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeHACK = function CategoryCodeHACK(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeHACK"), _react.default.createElement("path", {
    d: "M11.567,2.527H9.923a2.5,2.5,0,0,0-2.495,2.5v1.6H3.766A1.565,1.565,0,0,0,2.2,8.193v3.715a1.564,1.564,0,0,0,1.565,1.565H9.179a1.565,1.565,0,0,0,1.566-1.565V8.193A1.566,1.566,0,0,0,9.179,6.627H9.02v-1.6a.914.914,0,0,1,.9-.9h1.644a.914.914,0,0,1,.9.9V6.666h1.592V5.022A2.5,2.5,0,0,0,11.567,2.527ZM6.008,9.753l-2.256.952-.3-.7L5.166,9.33,3.449,8.62l.3-.666,2.256.957ZM8.99,12.147H6.206V11.4H8.99Z"
  })));
};

var _default = CategoryCodeHACK;
exports.default = _default;